<template>
	<div>
		<div class="row my-5 my-md-2 pl-2">
            <button class="btn btn-dark" type="button" data-toggle="collapse" data-target="#collapseGuide" aria-expanded="false" aria-controls="collapseGuide">
                Hướng dẫn
            </button>
        </div>
        <div class="collapse" id="collapseGuide">
            <div class="card card-body bg-dark text-light">
                <h2>App chấm Điểm rèn luyện HUST</h2>
                <div>B1) Nhập Token và Mã Sinh viên<small class="mx-1"><router-link :to="{ name: 'DRLHowTo' }" :target="dataFetched() ? '_blank' : ''">(Cách lấy Token)</router-link></small></div>
				<div class="ml-2">- Vào trang <a href="http://ctsv.hust.edu.vn" target="_blank">ctsv.hust.edu.vn</a></div>
				<div class="ml-2">- Gõ "javascript:" lên URL</div>
				<div class="ml-2">
					- Dán code
					<span class="text-secondary">/TokenCode=([^;]+);/.exec(document.cookie)[1]</span>
					vào sau "javascript:"
					(Nếu login bằng tài khoản <span class="text-danger">CTSV</span>)
				</div>
				<div class="ml-2">
					- Dán code
					<span class="text-secondary">localStorage.getItem('adal.idtoken')</span>
					vào sau "javascript:"
					(Nếu login bằng tài khoản <span class="text-danger">Microsoft</span>)
				</div>
				<div class="ml-2">- Nhấn Enter</div>
                B2) Nhấn "Tìm hoạt động"<br>
                B3) Nhấn vào các hoạt động, hoạt động được chọn và các tiêu chí phù hợp sẽ chuyển thành màu xanh lá<br>
                B4) Nhấn vào tiêu chí bạn muốn, hoạt động được chọn sẽ được chuyển xuống ngay dưới tên tiêu chí<br>
                <div>B5) Có thể bỏ chọn hoạt động bằng nút <i class="fas fa-minus-circle text-danger"></i><br></div>
                B6) Có thể xem các tiêu chí khác của hoạt động bằng cách di chuột vào<br>
                B7) Sau khi chấm điểm xong, nhấn lưu lại, thông tin sẽ được gửi tới cơ sở dữ liệu của trường<br>
                <br>
                <h3>TÍNH NĂNG:</h3>
                -Những tiêu chí đã có minh chứng sẽ chuyển thành màu xám<br>
                -Token Code chỉ cần lấy 1 lần sẽ tự động lưu trong máy<br>
                -Có thể lấy được Token Code cho cả Tài khoản login bằng CTSV hoặc Microsoft, kể cả khi login bằng điện thoại<br>
                -Nếu dùng điện thoại, có thể nhấn vào các hoạt động bên dưới tiêu chí để xem chi tiết<br>
            </div>
        </div>
	</div>
</template>

<script>
export default {
	props: ['allCriterias'],
	methods: {
		dataFetched () {
            return this.allCriterias.length > 0
        },
	},
}
</script>

<style>

</style>